module.exports = __webpack_public_path__ + "static/media/06.microsoft-edge.ea55ac7f.svg";